/* global define */

(function (global) {
	function factory() {
		'use strict';

		var COMPARE_RESULT = {
			LESS: 'Less',
			MORE: 'More',
			EQUALLY: 'Equally'

		};

		var mrgDeviceTools = {
			/**
			 *
			 * @param {object} supportedDevices
			 * объект описывает версии которые поддерживаются
			 * пример -
			 *  {
             *      'Android': '4.3.1',
             *      'Windows Phone': '3'
             *  }
			 * указывается минимальная версия включительно
			 * все что больше или равно подходит
			 *
			 * @param {object} currentDevice текущая версия устройства
			 * пример -
			 * {
             *      os: 'Android',
             *      osver: '5.0.1'
             * }
			 * @param {object} params
			 *                 params.osUndef=true в случае если не указана версия операционки что возвращаем
			 *                 params.osNotFound=false в случае если девайс не найден в конфиге что возвращаем
			 * @returns {boolean}
			 */
			isSupported: function (supportedDevices, currentDevice, params) {
				params = params || {};

				if (params.osUndef === void 0) {
					params.osUndef = true;
				}

				if (!currentDevice.os) {
					return !!params.osUndef;
				}

				if (!currentDevice.osver) {
					return false;
				}

				var findOs;
				currentDevice.os = currentDevice.os.toLowerCase();

				Object.keys(supportedDevices).forEach(function (os) {
					if (findOs) {
						return;
					}

					if (os.toLowerCase() === currentDevice.os) {
						findOs = supportedDevices[os];
					}
				});

				if (!findOs) {
					return !!params.osNotFound;
				}

				if (
					mrgDeviceTools.compareVersions(currentDevice.osver, findOs) === COMPARE_RESULT.LESS
				) {
					return false;
				} else {
					return true;
				}
			},

			/**
			 *
			 * @param {object} supportedUA
			 *    объект описывает версии которые поддерживаются
			 *  пример -
			 *  {
             *      'Msie': '8.0',
             *      'Chrome': '56.0.2924'
             *  }
			 *    указывается минимальная версия включительно
			 *    все что больше или равно подходит
			 *
			 * @param {object} currentUA текущая версия браузера
			 * можно получить из matchUserAgent
			 * пример -
			 * {
             *      browser: 'msie',
             *      version: '7.0'
             * }
			 * @param {object} params
			 *                 params.osUndef=true в случае если не указана версия операционки что возвращаем
			 *                 params.osNotFound=false в случае если девайс не найден в конфиге что возвращаем
			 * @returns {boolean}
			 */
			isSupportedUA: function (supportedUA, currentUA, params) {
				return this.isSupported(supportedUA, {
					os: currentUA.browser,
					osver: currentUA.version
				}, params);
			},

			/**
			 * Возвращает COMPARE_RESULT для ver1
			 *
			 * @param ver1
			 * @param ver2
			 * @returns {COMPARE_RESULT}
			 */
			compareVersions: function (ver1, ver2) {
				var result;

				var arr1 = ver1.split('.');
				var arr2 = ver2.split('.');

				var length = Math.max(arr1.length, arr2.length);

				for (var i = 0; i < length; i++) {
					var num1 = parseInt(arr1[i], 10);
					var num2 = parseInt(arr2[i], 10);

					if (isNaN(num1)) num1 = 0;
					if (isNaN(num2)) num2 = 0;

					if (num1 > num2) {
						result = COMPARE_RESULT.MORE;
						break;
					} else if (num1 < num2) {
						result = COMPARE_RESULT.LESS;
						break;
					}
				}

				result = result || COMPARE_RESULT.EQUALLY;
				return result;
			},

			/**
			 * Определяет версию браузера по юзерагенту
			 * Копипаста $.uaMatch
			 *
			 * @param {string} ua - строка UserAgent
			 * @returns {{browser: (string), version: (string)}}
			 */
			matchUserAgent: function (ua) {
				ua = ua.toLowerCase();

				var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
					/(webkit)[ \/]([\w.]+)/.exec(ua) ||
					/(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
					/(msie) ([\w.]+)/.exec(ua) ||
					ua.indexOf('compatible') < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
					[];

				var result = {
					browser: match[1] || '',
					version: match[2] || ''
				};

				result[result.browser] = true;

				// Chrome is Webkit, but Webkit is also Safari
				if (result.chrome) {
					result.webkit = true;
				} else if (result.webkit) {
					result.safari = true;
					result.browser = 'safari';
				}

				return result;
			}
		};

		mrgDeviceTools.COMPARE_RESULT = COMPARE_RESULT;

		return mrgDeviceTools;
	}

	if (typeof define === 'function') {
		define('mrg-device-tools', [], function () {
			return factory();
		});
	} else {
		global.mrgDeviceTools = factory();
	}
})(window);
